import React from 'react';

/** True for an employee whose account has been deactivated. */
export const isInactive = (person) => person?.status === 'INACTIVE';

/**
 * A small "Inactive" pill beside a name.
 *
 * Deactivated employees are hidden from pickers, counts and approval queues,
 * but they still appear on records they are part of (an expense they paid, a
 * task they did). This tag, with the greyed avatar EmployeeAvatar draws, is
 * what stops someone mistaking them for a current colleague. Renders nothing
 * for anyone active, or when the payload carries no status.
 */
const InactiveTag = ({ person }) => (
    isInactive(person)
        ? <span className="inactive-tag" title="This employee is no longer active">Inactive</span>
        : null
);

export default InactiveTag;
